import {
    MY_STOKKE_ADDRESSES_PAGE_ID,
    MY_STOKKE_DASHBOARD_PAGE_ID,
    MY_STOKKE_ORDERS_PAGE_ID,
    MY_STOKKE_PERSONAL_INFORMATION_PAGE_ID,
    MY_STOKKE_WARRANTY_PAGE_ID,
    MY_STOKKE_WISHLIST_PAGE_ID
} from '../../constants'
import {
    ThinStorefinderIcon,
    ThinHeartIcon,
    ThinBasketIcon,
    ThinWarrantyIcon,
    ThinAccountIcon,
    AccountIcon,
    BasketIcon,
    WarrantyIcon,
    StorefinderIcon,
    HeartIcon
} from '../../components/icons'
import {defineMessage} from 'react-intl'
import loadable from '@loadable/component'

const MyStokkeDashboard = loadable(() => import('./subpages/dashboard'))
const MyStokkePersonalData = loadable(() => import('./subpages/personal-data'))
const MyStokkeAddresses = loadable(() => import('./subpages/addresses'))
const MyStokkeOrders = loadable(() => import('./subpages/orders'))
const MyStokkeOrderDetails = loadable(() => import('./subpages/order-details'))
const MyStokkeWarrantyOverview = loadable(() => import('./subpages/warranty-overview'))
const MyStokkeWishlist = loadable(() => import('./subpages/wishlist'))

export default [
    {
        configId: MY_STOKKE_DASHBOARD_PAGE_ID,
        component: MyStokkeDashboard,
        path: '/',
        exact: true,
        icon: AccountIcon,
        dashboardIcon: ThinAccountIcon,
        label: defineMessage({id: 'mystokke.dashboard.headline', defaultMessage: 'My Stokke®'})
    },
    {
        configId: MY_STOKKE_ORDERS_PAGE_ID,
        component: MyStokkeOrders,
        path: '/orders',
        exact: true,
        icon: BasketIcon,
        dashboardIcon: ThinBasketIcon
    },
    {
        component: MyStokkeOrderDetails,
        path: '/orders/:orderId',
        exact: true
    },
    {
        configId: MY_STOKKE_WARRANTY_PAGE_ID,
        component: MyStokkeWarrantyOverview,
        path: '/warranty',
        exact: true,
        icon: WarrantyIcon,
        dashboardIcon: ThinWarrantyIcon
    },
    {
        configId: MY_STOKKE_PERSONAL_INFORMATION_PAGE_ID,
        component: MyStokkePersonalData,
        path: '/personal-information',
        exact: true
    },
    {
        configId: MY_STOKKE_ADDRESSES_PAGE_ID,
        component: MyStokkeAddresses,
        path: '/addresses',
        exact: true,
        icon: StorefinderIcon,
        dashboardIcon: ThinStorefinderIcon
    },
    {
        configId: MY_STOKKE_WISHLIST_PAGE_ID,
        component: MyStokkeWishlist,
        path: '/wishlist',
        exact: true,
        allowGuest: true,
        icon: HeartIcon,
        dashboardIcon: ThinHeartIcon
    }
]
